import Reveal from "@/components/Reveal";
import PartnerForm from "@/components/PartnerForm";

/**
 * Closes the page as an invitation to talk rather than a second pitch.
 *
 * Framed as an inset panel on paper white rather than another full-bleed band: the
 * page has had five of those by this point, and a contained close reads as a
 * deliberate final statement instead of one more stripe. Navy stays reserved for
 * the hero and the footer.
 */
const PartnerBand = () => {
  return (
    <section id="partners" className="bg-white pt-16 pb-20 md:pt-20 md:pb-28">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <Reveal>
          <div className="rounded-3xl border border-quietcove-blue/12 bg-secondary/60 px-5 py-12 sm:px-12 md:px-16 md:py-16">
            <div className="grid grid-cols-1 lg:grid-cols-[5fr_6fr] gap-12 lg:gap-20 items-start">
              <div className="lg:pt-2">
                <div className="flex items-center gap-4 mb-6">
                  <span className="h-px w-10 bg-gold" />
                  <p className="text-gold-deep text-xs sm:text-sm font-semibold uppercase tracking-[0.22em]">
                    Let&rsquo;s connect
                  </p>
                </div>

                <h2 className="font-display text-[2.1rem] md:text-[2.8rem] font-bold tracking-[-0.025em] leading-[1.08] text-quietcove-blue text-balance">
                  Have a lobby, a concourse, or a show floor?
                </h2>

                <p className="text-quietcove-grey text-lg leading-relaxed mt-6 max-w-sm">
                  We install, operate, and support the pods. Tell us about your space and we will
                  map out the fit.
                </p>
              </div>

              <PartnerForm />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default PartnerBand;
